/*
 * @Description:
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  上一页: 'Previous Page',
  页: 'Page',
  下一页: 'Next Page',
  放大: 'Zoom In',
  缩小: 'Zoom Out',
  旋转: 'Rotate',
  原始尺寸: 'Original Size',
  适应页面: 'Fit Page',
  预览: 'Preview',
  删除: 'Delete',
  无命名文件: 'Unnamed File',
  '文件已下载完成，可通过浏览器下载文件夹查看': 'The file has been downloaded successfully. You can view it in the browser folder.',
  '文件已下载完成，可通过飞书左下角近期下载文件夹查看': 'The file has been downloaded and can be viewed in the Recently Downloaded Files folder at the bottom left of Feishu',
  下载失败请重试: 'Download failed. Please try again.',
  本字段只支持移动端拍照上传: 'This field only supports mobile phone camera upload.',
  '下载失败，请重试！': 'Download failed. Please try again.',
  '获取文件失败，请重试！': 'Failed to get file. Please try again.',
  粘贴或拖拽上传: 'Paste or drag upload',
  粘贴或拖拽至这里上传: 'Paste or drag to upload here',
  添加本地文件: 'Add local file',
  重试: 'Retry',
  上传附件: 'Upload attachment'
};
